import { CurrencyRecord, SupportedCurrency } from '../domain/currency';
import { TransportOrder } from '../domain/transportOrder';

export const calculateProfitForCurrency = (transportOrder: TransportOrder, forCurrency: SupportedCurrency, currencyRecord: CurrencyRecord) => {
    if (isNaN(Number(transportOrder.freight.value)) || isNaN(Number(transportOrder.freight.clientValue))) {
        return 0;
    }

    const { freight } = transportOrder;
    const clientCurrency = freight.clientCurrency;

    // If the target currency is the same as client currency, we only need to convert the value
    if (forCurrency === clientCurrency) {
        if (forCurrency === freight.currency) {
            return (Number(freight.clientValue) || 0) - (Number(freight.value) || 0);
        }

        // client currency is as expected but contractor pays in different one
        const currencyRate = currencyRecord[forCurrency];
        const convertedContractorValue = (Number(freight.value) || 0) / currencyRate.exchangeRate;

        return Number(freight.clientValue) - convertedContractorValue;
    }

    const convertedClientValue = (Number(freight.clientValue) || 0) / currencyRecord[forCurrency].exchangeRate;
    const convertedContractorValue = freight.currency === forCurrency ? (Number(freight.value) || 0) : (Number(freight.value) || 0) / currencyRecord[forCurrency].exchangeRate;


    return convertedClientValue - convertedContractorValue;
};